import Pocketbase from "pocketbase"
import {createContext} from "react";
const pb = new Pocketbase()
const ApiContext = createContext(pb)
export default ApiContext
